import '@/styles/fonts.css'
import '@/styles/tokens.css'
import '@/styles/global.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/App'

const container = document.getElementById('root')
if (!container) throw new Error('index.html is missing <div id="root">')

// StrictMode stays on: every effect must be cleanup-safe (useGSAP handles GSAP for you).
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
